import React from 'react';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import DropdownList from 'react-widgets/lib/DropdownList';
import {
  Button,
  Glyphicon,
  InputGroup,
} from 'react-bootstrap';

import { querySelector } from '../../../utils';

/* eslint-disable */
const propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  data: PropTypes.object,
  allUsers: PropTypes.array,
  disabled: PropTypes.bool,
  allowClearInput: PropTypes.bool,
};
/* eslint-enable */

const UserInput = (props) => {
  const { allUsers, value, onChange, disabled, allowClearInput } = props;
  return (
    <div>
      <InputGroup style={{ width: '100%' }}>
        <DropdownList
          inputProps={{
            className: 'form-control',
          }}
          filter="contains"
          allowCreate="onFilter"
          value={value}
          data={allUsers}
          onChange={onChange}
          disabled={disabled}
          valueField="id"
          textField="fullname"
        />
        {allowClearInput && (
          <InputGroup.Button>
            <Button
              name="cancel"
              disabled={!value}
              onClick={() => { onChange(null); }}
            >
              <Glyphicon glyph="remove" />
            </Button>
          </InputGroup.Button>
        )}
      </InputGroup>
    </div>
  );
};

const GetAllUsersQuery = gql`
  query GetAllUsers{
    all_users(exclude_salary: false, exclude_terminated: true) {
      edges {
        node {
          id
          fullname
        }
      }
    }
  }
`;

export const marshallData = ({ data, ownProps }) => {
  const allUsers = querySelector(data, '$.all_users.edges[*].node', []);
  return {
    data,
    ...ownProps,
    allUsers: [{ id: null, fullname: 'None' }, ...allUsers],
  };
};

const withData = graphql(GetAllUsersQuery, { props: marshallData });

UserInput.propTypes = propTypes;
UserInput.defaultProps = {
  disabled: false,
  allowClearInput: true,
};

export default withData(UserInput);
